import {ServiceBase} from '../ServiceBase';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {ApiControllerBase} from './api-controller-base';

export type ClockController_GetCurrentServerTimeResponse = {
	ServerTime: string;
};

export class ClockController extends ApiControllerBase {
	getCurrentServerTime(): Promise<ClockController_GetCurrentServerTimeResponse> {
		return this._httpGet('cgpapi/time/current');
	}

}

export type BonusManagerController_GetEligiblePromotionCodesResponse = Array<string>;

export class BonusManagerController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/bonusManager/'
	}
	getEligiblePromotionCodes(): Promise<BonusManagerController_GetEligiblePromotionCodesResponse> {
		return this._httpPost('getEligiblePromotionCodes');
	}

}

export type FeatureToggleManagementController_SetFeatureCounterRequest = {
	FeatureID: number;
};

export type FeatureToggleManagementController_GetFeaturesDataForCIDResponse = Array<{
	FeatureID: number;
	DisplayCount: number;
}>;

export class FeatureToggleManagementController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/featureToggleManagement/'
	}
	setFeatureCounter(request: FeatureToggleManagementController_SetFeatureCounterRequest): Promise<void> {
		return this._httpPost('setFeatureCounter', request);
	}

	getFeaturesDataForCID(): Promise<FeatureToggleManagementController_GetFeaturesDataForCIDResponse> {
		return this._httpPost('getFeaturesData');
	}

}

export type GamblingSessionController_StartGamblingSessionRequest = {
	correlationId: string;
	lossLimitAmount: number;
	sessionDurationLimitInSeconds: number;
	reminderIntervalInSeconds: number;
	restrictionPeriodInSeconds: number;
};

export type GamblingSessionController_StartGamblingSessionResponse = {
	gamblingSessionId: string;
	errorCode: number;
	sessionRestrictionExpirationDate?: number;
};

export type GamblingSessionController_CreateGamblingSessionResponse = {
	gamblingSessionId: string;
	errorCode: number;
};

export class GamblingSessionController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/gamblingSession/'
	}
	startGamblingSession(clientRequest: GamblingSessionController_StartGamblingSessionRequest): Promise<GamblingSessionController_StartGamblingSessionResponse> {
		return this._httpPost('start', clientRequest);
	}

	createGamblingSession(): Promise<GamblingSessionController_CreateGamblingSessionResponse> {
		return this._httpPost('create');
	}

}

export type GamesCorrelationController_GetCorrelatedGamesV2Request = {
	gameType: number;
};

export type GamesCorrelationController_GetCorrelatedGamesV2Response = {
	correlatedGameTypes: Array<number>;
};

export class GamesCorrelationController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/gamesCorrelation/'
	}
	getCorrelatedGamesV2(request: GamesCorrelationController_GetCorrelatedGamesV2Request): Promise<GamesCorrelationController_GetCorrelatedGamesV2Response> {
		return this._httpPost('v2/getCorrelatedGames', request);
	}

}

export type ABTestingController_GetTestsForAnonymousPlayerRequest = {
	anonymousPlayerId?: string;
	brandId: number;
	subBrandId: number;
	countryCode: string;
	isMobile: boolean;
};

export type ABTestingController_GetTestsForAnonymousPlayerResponse = {
	Features: Record<string, {
		TestId: number;
		GroupName: string;
		FeatureName: string;
		Properties: Record<string, any>;
	}>;
	AnonymousPlayerId: string;
};

export class ABTestingController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/abTesting/'
	}
	getTestsForAnonymousPlayer(request: ABTestingController_GetTestsForAnonymousPlayerRequest): Promise<ABTestingController_GetTestsForAnonymousPlayerResponse> {
		return this._httpPost('getTestsForAnonymousPlayer', request);
	}

}

export type InsightController_GetLiveCasinoGameRecommendationsForPlayerRequest = {
	engineType: number;
};

export type InsightController_GetLiveCasinoGameRecommendationsForPlayerResponse = {
	Engine: string;
	GameTypes: Array<number>;
	ErrorCode: number;
	ErrorDescription: string;
};

export type InsightController_GetCasinoRecommendedDynamicListsForPlayerRequest = {
	listsIDs: Array<string>;
};

export type InsightController_GetCasinoRecommendedDynamicListsForPlayerResponse = Record<number, number>;

export type InsightController_GetTrendingRecommendedGamesForPlayerRequest = {
	listTypeIds: Array<number>;
	subBrandId: number;
	countryCode: string;
};

export type InsightController_GetTrendingRecommendedGamesForPlayerResponse = Record<number, Array<number>>;

export type InsightController_GetGameRecommendationsForPlayerRequest = {
	engineType: number;
};

export type InsightController_GetGameRecommendationsForPlayerResponse = {
	Engine: string;
	GameTypes: Array<number>;
	ErrorCode: number;
	ErrorDescription: string;
};

export type InsightController_GetRecentlyAddedGamesRecommendationsForPlayerRequest = {
	engineType: number;
};

export type InsightController_GetRecentlyAddedGamesRecommendationsForPlayerResponse = {
	Engine: string;
	GameTypes: Array<number>;
	ErrorCode: number;
	ErrorDescription: string;
};

export class InsightController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/insight/'
	}
	getLiveCasinoGameRecommendationsForPlayer(request: InsightController_GetLiveCasinoGameRecommendationsForPlayerRequest): Promise<InsightController_GetLiveCasinoGameRecommendationsForPlayerResponse> {
		return this._httpPost('getLiveCasinoGameRecommendationsForPlayer', request);
	}

	getCasinoRecommendedDynamicListsForPlayer(req: InsightController_GetCasinoRecommendedDynamicListsForPlayerRequest): Promise<InsightController_GetCasinoRecommendedDynamicListsForPlayerResponse> {
		return this._httpPost('getCasinoRecommendedDynamicLists', req);
	}

	getTrendingRecommendedGamesForPlayer(req: InsightController_GetTrendingRecommendedGamesForPlayerRequest): Promise<InsightController_GetTrendingRecommendedGamesForPlayerResponse> {
		return this._httpPost('getTrendingRecommendedGamesForPlayer', req);
	}

	getGameRecommendationsForPlayer(req: InsightController_GetGameRecommendationsForPlayerRequest): Promise<InsightController_GetGameRecommendationsForPlayerResponse> {
		return this._httpPost('getGameRecommendationsForPlayer', req);
	}

	getRecentlyAddedGamesRecommendationsForPlayer(req: InsightController_GetRecentlyAddedGamesRecommendationsForPlayerRequest): Promise<InsightController_GetRecentlyAddedGamesRecommendationsForPlayerResponse> {
		return this._httpPost('getRecentlyAddedGamesRecommendationsForPlayer', req);
	}

}

export type JackpotBetsController_GetParticipationDataResponse = {
	OptStatus: number;
	ParticipationFee?: number;
	MinimuBet?: number;
	CurrencyCode: string;
	ErrorCode: number;
	ErrorDescription: string;
};

export type JackpotBetsController_OptInToJackpotBetsResponse = {
	ErrorCode: number;
	ErrorDescription: string;
};

export type JackpotBetsController_OptOutFromJackpotBetsResponse = {
	ErrorCode: number;
	ErrorDescription: string;
};

export type JackpotBetsController_GetBrandJackpotsRequest = {
	brandId: number;
	currencyCode: string;
};

export type JackpotBetsController_GetBrandJackpotsResponse = {
	winnersCount: number;
	totalWinsToday: number;
	jackpotsPrizes: Array<{
		jackpotId: number;
		amount: number;
	}>;
};

export class JackpotBetsController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/jackpotBets/'
	}
	getParticipationData(): Promise<JackpotBetsController_GetParticipationDataResponse> {
		return this._httpPost('getParticipationData');
	}

	optInToJackpotBets(): Promise<JackpotBetsController_OptInToJackpotBetsResponse> {
		return this._httpPost('optIn');
	}

	optOutFromJackpotBets(): Promise<JackpotBetsController_OptOutFromJackpotBetsResponse> {
		return this._httpPost('optOut');
	}

	getBrandJackpots(request: JackpotBetsController_GetBrandJackpotsRequest): Promise<JackpotBetsController_GetBrandJackpotsResponse> {
		return this._httpPost('feedsByBrand', request);
	}

}

export type JackpotFeedsController_GetBrandJackpotsRequest = {
	brandId: number;
	currency: string;
};

export type JackpotFeedsController_GetBrandJackpotsResponse = {
	jackpots: Array<{
		id: number;
		amountInCents: number;
		state: number;
		lastWinAmountInCents: number;
		mustHitTime?: string;
		gameTypes: Array<number>;
	}>;
};

export class JackpotFeedsController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/jackpotFeeds/'
	}
	getBrandJackpots(request: JackpotFeedsController_GetBrandJackpotsRequest): Promise<JackpotFeedsController_GetBrandJackpotsResponse> {
		return this._httpPost('byBrand', request);
	}

}

export type LocationController_DetectUserIpRequest = {
	PreviousIpAddress?: string;
	PreviousIpAddresses: Array<string>;
};

export type LocationController_DetectUserIpResponse = {
	CurrentIpAddress: string;
};

export type LocationController_DetectUserIpV2Request = {
	PreviousIpAddresses: string;
};

export type LocationController_DetectUserIpV2Response = {
	EncryptedIpAddress: string;
	ChangeDetected: boolean;
	PreviousIP: string;
	CurrentIP: string;
};

export class LocationController extends ApiControllerBase {
	getCountryByIP(): Promise<any> {
		return this._httpPost('cgpapi/location/GetCountryByIP');
	}

	getCountryByIPOld(): Promise<any> {
		return this._httpPost('api/GetCountryByIP');
	}

	detectUserIp(request: LocationController_DetectUserIpRequest): Promise<LocationController_DetectUserIpResponse> {
		return this._httpPost('cgpapi/location/ipDetection', request);
	}

	detectUserIpV2(request: LocationController_DetectUserIpV2Request): Promise<LocationController_DetectUserIpV2Response> {
		return this._httpPost('cgpapi/location/v2/ipDetection', request);
	}

}

export type NetPositionController_InitializeNetPositionForGameTypeRequest = {
	GameType: number;
};

export type NetPositionController_InitializeNetPositionForGameTypeResponse = {
	code: number;
	message: string;
	response_time: number;
	ErrorCode: number;
	ErrorDescription: string;
};

export class NetPositionController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/netPosition/'
	}
	initializeNetPositionForGameType(request: NetPositionController_InitializeNetPositionForGameTypeRequest): Promise<NetPositionController_InitializeNetPositionForGameTypeResponse> {
		return this._httpPost('initialize', request);
	}

}

export type OMGController_GetAwaitingMessagesResponse = {
	MessagesDetails: string;
	MessagesJSON: any;
};

export class OMGController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/omg/'
	}
	getAwaitingMessages(): Promise<OMGController_GetAwaitingMessagesResponse> {
		return this._httpPost('GetAwaitingMessages');
	}

}

export type OpenSessionsController_GetOpenSessionsRequest = {
	realGameTypes?: Array<number>;
	freePlayGameTypes?: Array<number>;
	openSessionsKind: number;
};

export type OpenSessionsController_GetOpenSessionsResponse = {
	sessionDetails: Array<{
		Credit: number;
		GameTypeID: number;
		SessionID: string;
		FreePlayID?: string;
		TotalBets?: number;
		TotalWins?: number;
		UpdatedGameSessionLimit?: number;
		IntervalReminderInMinutes?: number;
		RequestedTimeLimitInMinutes?: number;
		GameStartDate?: string;
		RestrictionPeriodInMinutes?: number;
		RegulationAdditionalData: any;
	}>;
};

export class OpenSessionsController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/openSessions/'
	}
	getOpenSessions(request: OpenSessionsController_GetOpenSessionsRequest): Promise<OpenSessionsController_GetOpenSessionsResponse> {
		return this._httpPost('getOpenSessions', request);
	}

}

export type RestrictionRulerController_GetRestrictionActionsRequest = {
	RequestedAction: string;
};

export type RestrictionRulerController_GetRestrictionActionsResponse = {
	actions: Array<{
		type: string;
		actionData: any;
		orderId: number;
	}>;
	ErrorCode: number;
	ErrorDescription: string;
};

export type RestrictionRulerController_NotifyRestrictionActionPerformedRequest = {
	restrictionRuleActionType: string;
	actionData: string;
};

export class RestrictionRulerController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/restrictionRuler/'
	}
	getRestrictionActions(request: RestrictionRulerController_GetRestrictionActionsRequest): Promise<RestrictionRulerController_GetRestrictionActionsResponse> {
		return this._httpPost('getRestrictionActions', request);
	}

	notifyRestrictionActionPerformed(clientRequest: RestrictionRulerController_NotifyRestrictionActionPerformedRequest): Promise<void> {
		return this._httpPost('notifyRestrictionActionPerformed', clientRequest);
	}

}

export type RestrictionsController_GetAnonymousRestrictionsRequest = {
	BrandId: number;
	SubBrandId: number;
	ClientVersion: string;
	ProductPackage: number;
	FakeClientIP: string;
};

export type RestrictionsController_GetAnonymousRestrictionsResponse = {
	RestrictionsByAction: Array<{
		ExtensionData: {
		};
		ActionId: number;
		ActionName: string;
		Entities: Array<{
			ExtensionData: {
			};
			DisplayId: boolean;
			EntityId: number;
			EntityName: string;
			Values: Array<{
				ExtensionData: {
				};
				CreationDate: string;
				ExpirationDate?: string;
				ReasonId: number;
				SecondsToExpire?: number;
				TimingPeriodEndTimeUtc: string;
				TimingPeriodStartTimeUtc: string;
				Value: string;
			}>;
		}>;
	}>;
};

export type RestrictionsController_SetCoolDownRestrictionRequest = {
	CoolDownTimeInSeconds: number;
	FakeClientIP?: string;
};

export class RestrictionsController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/restrictions/'
	}
	getAnonymousRestrictions(request: RestrictionsController_GetAnonymousRestrictionsRequest): Promise<RestrictionsController_GetAnonymousRestrictionsResponse> {
		return this._httpPost('anonymousRestrictions', request);
	}

	setCoolDownRestriction(request: RestrictionsController_SetCoolDownRestrictionRequest): Promise<string> {
		return this._httpPost('setCoolDownRestriction', request);
	}

}

export type ThirdPartyFreePlayController_GetAllVouchersResponse = {
	FreePlayBonusList: Array<{
		CompanyID: number;
		CurrencyCode: string;
		CurrentWinningAmount: number;
		CreationDate?: string;
		ExpirationDate: string;
		FreePlayID: string;
		FreePlayTypeID: number;
		GameTypesIDs: Array<number>;
		AwardedFreePlayAmount: number;
		BonusStatus: number;
		FreeSpinsInfo?: {
			BetPerSpin: number;
			NumberOfAwardedFreeSpins: number;
			NumberOfFreeSpinsLeft: number;
		};
		VoucherInfo?: {
			RemainingFreePlayAmount: number;
		};
		NumberOfAwardedFreeSpins: number;
		NumberOfFreeSpinsLeft: number;
		BetPerSpin: number;
	}>;
};

export type ThirdPartyFreePlayController_ClaimFreePlayRequest = {
	FreePlayId: string;
	GameType: number;
};

export class ThirdPartyFreePlayController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/freeplay/3rdparty/'
	}
	getAllVouchers(): Promise<ThirdPartyFreePlayController_GetAllVouchersResponse> {
		return this._httpPost('GetAllVouchers');
	}

	claimFreePlay(request: ThirdPartyFreePlayController_ClaimFreePlayRequest): Promise<void> {
		return this._httpPost('ClaimFreePlay', request);
	}

}

export type UserEligibilityController_DepositWidgetEligibilityRequest = {
	LoginCountry: string;
	StateID?: number;
};

export type UserEligibilityController_DepositWidgetEligibilityResponse = {
	isEligible: boolean;
	ineligibleReason: string;
	errorID: number;
	errorDescription: string;
	hasErrors: boolean;
};

export type UserEligibilityController_CashoutWidgetEligibilityRequest = {
	LoginCountry: string;
	StateID?: number;
};

export type UserEligibilityController_CashoutWidgetEligibilityResponse = {
	isEligible: boolean;
	ineligibleReason: string;
	errorID: number;
	errorDescription: string;
	hasErrors: boolean;
};

export type UserEligibilityController_TransactionHistoryWidgetEligibilityRequest = {
	LoginCountry: string;
	StateID?: number;
};

export type UserEligibilityController_TransactionHistoryWidgetEligibilityResponse = {
	isEligible: boolean;
	ineligibleReason: string;
	errorID: number;
	errorDescription: string;
	hasErrors: boolean;
};

export class UserEligibilityController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/userEligibility/'
	}
	depositWidgetEligibility(request: UserEligibilityController_DepositWidgetEligibilityRequest): Promise<UserEligibilityController_DepositWidgetEligibilityResponse> {
		return this._httpPost('depositWidget', request);
	}

	cashoutWidgetEligibility(request: UserEligibilityController_CashoutWidgetEligibilityRequest): Promise<UserEligibilityController_CashoutWidgetEligibilityResponse> {
		return this._httpPost('cashoutWidget', request);
	}

	transactionHistoryWidgetEligibility(request: UserEligibilityController_TransactionHistoryWidgetEligibilityRequest): Promise<UserEligibilityController_TransactionHistoryWidgetEligibilityResponse> {
		return this._httpPost('transactionHistoryWidget', request);
	}

}

export type GameController_GetGameTokenRequest = {
	gameTypeId: number;
	regulationId: number;
	isMobile: boolean;
	isHybridEmbedded: boolean;
	currentRoute: string;
	currencyCode: string;
	languageCode: string;
	refreshToken: string;
	productPackage: number;
	GrsData?: string;
	WrapperState?: string;
	isSupportHTML5?: boolean;
	isSupportFlash?: boolean;
	GameState?: string;
	AdditionalState?: string;
	PreloaderState?: string;
	GameTechnology?: string;
	GrsEnvironment?: string;
	realityCheckIntervalInMinutes?: number;
	sessionTimerInSeconds?: number;
	gameRoundId?: string;
	gameRoundDate?: string;
	reconnectionGameSessionId?: string;
	requestedGameLimitAmount?: number;
	requestedTimeLimitInMinutes?: number;
	restrictionPeriodInMinutes?: number;
	intervalReminderInMinutes?: number;
	FakeClientIP?: string;
	useEvolutionNewIntegration?: boolean;
	useAdapter?: boolean;
	vendorEnvironment?: string;
	isFreePlay?: boolean;
	usePariplayAdapterIntegration?: boolean;
	usePlayNGoNewAdapterIntegration?: boolean;
	jackpotAmount?: number;
};

export type GameController_GetGameTokenResponse = {
	Token: string;
	UserHasPendingActions: boolean;
	Restrictions: Array<{
		ExtensionData: {
		};
		ActionId: number;
		RestrictedEntities: Array<{
			ExtensionData: {
			};
			EntityTypeId: number;
			ReasonId: number;
			RestrictedValues: Array<string>;
			SecondsToExpire: number;
		}>;
	}>;
	NightLimitExpirationDate?: string;
	LugasActiveOnAnotherOperator: boolean;
	LugasCooldown: boolean;
};

export type GameController_OpenRealGameRequest = {
	gameTypeId: number;
	regulationId: number;
	isMobile: boolean;
	isHybridEmbedded: boolean;
	currentRoute: string;
	currencyCode: string;
	languageCode: string;
	refreshToken: string;
	productPackage: number;
	GrsData?: string;
	WrapperState?: string;
	isSupportHTML5?: boolean;
	isSupportFlash?: boolean;
	GameState?: string;
	AdditionalState?: string;
	PreloaderState?: string;
	GameTechnology?: string;
	GrsEnvironment?: string;
	realityCheckIntervalInMinutes?: number;
	sessionTimerInSeconds?: number;
	gameRoundId?: string;
	gameRoundDate?: string;
	reconnectionGameSessionId?: string;
	requestedGameLimitAmount?: number;
	requestedTimeLimitInMinutes?: number;
	restrictionPeriodInMinutes?: number;
	intervalReminderInMinutes?: number;
	FakeClientIP?: string;
	useEvolutionNewIntegration?: boolean;
	useAdapter?: boolean;
	vendorEnvironment?: string;
	isFreePlay?: boolean;
	usePariplayAdapterIntegration?: boolean;
	usePlayNGoNewAdapterIntegration?: boolean;
	jackpotAmount?: number;
};

export type GameController_OpenAnonymousGameRequest = {
	gameTypeId: number;
	regulationId: number;
	isMobile: boolean;
	isHybridEmbedded: boolean;
	currentRoute: string;
	currencyCode: string;
	languageCode: string;
	refreshToken: string;
	productPackage: number;
	GrsData?: string;
	WrapperState?: string;
	isSupportHTML5?: boolean;
	isSupportFlash?: boolean;
	GameState?: string;
	AdditionalState?: string;
	PreloaderState?: string;
	GameTechnology?: string;
	GrsEnvironment?: string;
	realityCheckIntervalInMinutes?: number;
	sessionTimerInSeconds?: number;
	gameRoundId?: string;
	gameRoundDate?: string;
	reconnectionGameSessionId?: string;
	requestedGameLimitAmount?: number;
	requestedTimeLimitInMinutes?: number;
	restrictionPeriodInMinutes?: number;
	intervalReminderInMinutes?: number;
	FakeClientIP?: string;
	useEvolutionNewIntegration?: boolean;
	useAdapter?: boolean;
	vendorEnvironment?: string;
	isFreePlay?: boolean;
	usePariplayAdapterIntegration?: boolean;
	usePlayNGoNewAdapterIntegration?: boolean;
	jackpotAmount?: number;
};

export type GameController_OpenGameHistoryRequest = {
	gameTypeId: number;
	regulationId: number;
	isMobile: boolean;
	isHybridEmbedded: boolean;
	currentRoute: string;
	currencyCode: string;
	languageCode: string;
	refreshToken: string;
	productPackage: number;
	GrsData?: string;
	WrapperState?: string;
	isSupportHTML5?: boolean;
	isSupportFlash?: boolean;
	GameState?: string;
	AdditionalState?: string;
	PreloaderState?: string;
	GameTechnology?: string;
	GrsEnvironment?: string;
	realityCheckIntervalInMinutes?: number;
	sessionTimerInSeconds?: number;
	gameRoundId?: string;
	gameRoundDate?: string;
	reconnectionGameSessionId?: string;
	requestedGameLimitAmount?: number;
	requestedTimeLimitInMinutes?: number;
	restrictionPeriodInMinutes?: number;
	intervalReminderInMinutes?: number;
	FakeClientIP?: string;
	useEvolutionNewIntegration?: boolean;
	useAdapter?: boolean;
	vendorEnvironment?: string;
	isFreePlay?: boolean;
	usePariplayAdapterIntegration?: boolean;
	usePlayNGoNewAdapterIntegration?: boolean;
	jackpotAmount?: number;
};

export type GameController_GetGameSessionDataRequest = {
	gameTypeId: number;
	useFreePlayUtilities?: boolean;
};

export type GameController_GetGameSessionDataResponse = {
	TransactionId: string;
	GameSessionId: string;
	LimitPercentageReminder: boolean;
	OriginalGameLimit: number;
	RequestedTimeLimit: number;
	SessionStartDate: string;
	TotalBets: number;
	TotalWins: number;
	UpdatedGameSessionLimit: number;
	RegulationData: any;
	PlayerBalance: number;
};

export type GameController_IncreaseGameSessionLimitRequest = {
	transactionId: string;
	amount: number;
	ticketId: number;
};

export type GameController_GetThirdPartyInternalGameTypeRequest = {
	externalGameCode: string;
	externalSubGameType?: string;
	companyId: number;
};

export type GameController_GetThirdPartyInternalGameTypeResponse = {
	GameType: number;
};

export class GameController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/game/'
	}
	getGameToken(openGameParams: GameController_GetGameTokenRequest): Promise<GameController_GetGameTokenResponse> {
		return this._httpPost('GetGameToken', openGameParams);
	}

	openRealGame(openGameParams: GameController_OpenRealGameRequest): Promise<any> {
		return this._httpPost('OpenRealGame', openGameParams);
	}

	openAnonymousGame(openGameParams: GameController_OpenAnonymousGameRequest): Promise<any> {
		return this._httpPost('OpenAnonymousGame', openGameParams);
	}

	openGameHistory(openGameParams: GameController_OpenGameHistoryRequest): Promise<any> {
		return this._httpPost('OpenGameHistory', openGameParams);
	}

	getGameSessionData(request: GameController_GetGameSessionDataRequest): Promise<GameController_GetGameSessionDataResponse> {
		return this._httpPost('GetGameSessionData', request);
	}

	increaseGameSessionLimit(request: GameController_IncreaseGameSessionLimitRequest): Promise<any> {
		return this._httpPost('increaseGameSessionLimit', request);
	}

	getThirdPartyInternalGameType(request: GameController_GetThirdPartyInternalGameTypeRequest): Promise<GameController_GetThirdPartyInternalGameTypeResponse> {
		return this._httpPost('getThirdPartyInternalGameType', request);
	}

}

export type HistoryController_GetDailyDealResponse = Array<{
	MarketingCampaignId: string;
}>;

export type HistoryController_GetHistoryRequest = {
	pageNumber: number;
	pageSize?: number;
	fromLastDays: number;
	requestKey?: string;
	minDate?: string;
	maxDate?: string;
};

export type HistoryController_GetHistoryResponse = {
	GameHistoryData: Array<{
		AdditionalData: any;
		AmountCurrencyISOCode: string;
		AvailableMoneyPerOffering: number;
		AllowedPlatformType: string;
		BetAmount: number;
		Date: string;
		TimeSincePlay: string;
		FreePlayCurrentAmount?: number;
		FreePlayWinningAmount?: number;
		GameId: string;
		GameTypeId: number;
		OriginalWinningsAmount?: number;
		ProductPackageID: number;
		ProfitAmount: number;
		SubBrandId?: number;
		VatBetFee: number;
		VendorName: string;
		VendorId: number;
		FreePlayReachedMaxWinCap?: boolean;
		CompanyName: string;
		GameGroupId: number;
		IsSupportDetailedHistory: boolean;
		IsBigWin: boolean;
	}>;
	PagingData: Array<{
		RequestKey: string;
		PageNumber: number;
		MinDate: string;
		MaxDate: string;
	}>;
};

export type HistoryController_GetMigratedHistoryRequest = {
	limit?: number;
	offset: number;
	fromLastDays: number;
};

export type HistoryController_GetMigratedHistoryResponse = {
	GameHistoryData: Array<{
		Currency: string;
		AvailableMoneyPerOffering: number;
		AllowedPlatformType: string;
		BetAmount: number;
		Date: string;
		TimeSincePlay: string;
		GameId: string;
		GameTypeId: string;
		GameName: string;
		ProductPackageID: number;
		ProfitAmount: number;
		SubBrandId?: number;
		GameGroupId: number;
	}>;
	PagingData: {
		PageNumber: number;
		PageSize: number;
	};
};

export type HistoryController_GetJpBetHistoryRequest = {
	pageNumber: number;
	pageSize?: number;
	fromLastDays: number;
	requestKey?: string;
	minDate?: string;
	maxDate?: string;
};

export type HistoryController_GetJpBetHistoryResponse = {
	GameHistoryData: Array<{
		AmountCurrencyISOCode: string;
		AllowedPlatformType: string;
		BetAmount?: number;
		TotalWins: number;
		Date: string;
		TimeSincePlay: string;
		DateInTimeZone?: string;
		GameId: string;
		GameTypeId: number;
		GameTypeName: string;
		ProductPackageID: number;
		ProfitAmount: number;
		RoundId?: number;
		ServerId: number;
		SubBrandId?: number;
		TimeZoneName: string;
		UnixTimeInTimeZone?: {
		};
		VendorName: string;
		VendorId: number;
		CompanyName: string;
		GameGroupId: number;
		IsSupportDetailedHistory: boolean;
	}>;
	PagingData: Array<{
		RequestKey: string;
		PageNumber: number;
		MinDate: string;
		MaxDate: string;
	}>;
};

export type HistoryController_GetTippingHistoryRequest = {
	fromLastDays: number;
	minDate?: string;
	maxDate?: string;
};

export type HistoryController_GetTippingHistoryResponse = {
	TipHistory: Array<{
		GameTypeID: number;
		TipID: number;
		TipDateTime: string;
		TipAmount: number;
		AvailableBalanceAfterAction: number;
		CurrencyCode: string;
	}>;
	MinDate: string;
	MaxDate: string;
};

export type HistoryController_GetGameSessionHistoryRequest = {
	pageNumber: number;
	pageSize?: number;
	fromLastDays: number;
	requestKey?: string;
	minDate?: string;
	maxDate?: string;
};

export type HistoryController_GetGameSessionHistoryResponse = {
	GameHistoryData: Array<{
		CurrencyCodeISO3: string;
		GameGroupId?: number;
		GameSessionId: string;
		GameTypeId?: number;
		SessionEndDateTime: string;
		SessionBalance: number;
		TotalBets: number;
		TotalWins: number;
		VendorName: string;
		VendorId: number;
		CompanyName: string;
	}>;
	PagingData: Array<{
		RequestKey: string;
		PageNumber: number;
		MinDate: string;
		MaxDate: string;
	}>;
};

export type HistoryController_GetRecentlyPlayedGamesResponse = {
	gameTypes: Array<number>;
};

export class HistoryController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/history/'
	}
	getDailyDeal(): Promise<HistoryController_GetDailyDealResponse> {
		return this._httpPost('dailyDeal');
	}

	getHistory(req: HistoryController_GetHistoryRequest): Promise<HistoryController_GetHistoryResponse> {
		return this._httpPost('getGammingHistory', req);
	}

	getMigratedHistory(req: HistoryController_GetMigratedHistoryRequest): Promise<HistoryController_GetMigratedHistoryResponse> {
		return this._httpPost('getMigratedGammingHistory', req);
	}

	getJpBetHistory(req: HistoryController_GetJpBetHistoryRequest): Promise<HistoryController_GetJpBetHistoryResponse> {
		return this._httpPost('jpBetHistory', req);
	}

	getTippingHistory(req: HistoryController_GetTippingHistoryRequest): Promise<HistoryController_GetTippingHistoryResponse> {
		return this._httpPost('getTippingHistory', req);
	}

	getGameSessionHistory(req: HistoryController_GetGameSessionHistoryRequest): Promise<HistoryController_GetGameSessionHistoryResponse> {
		return this._httpPost('getSessionHistory', req);
	}

	getRecentlyPlayedGames(): Promise<HistoryController_GetRecentlyPlayedGamesResponse> {
		return this._httpPost('getRecentlyPlayedGames');
	}

}

export type UserController_GetTokenRequest = {
	TargetType?: number;
	TargetTypeValue?: string;
	TargetProductPackage?: number;
};

export type UserController_GetTokenResponse = {
	token: string;
};

export type UserController_GetRealityCheckDataResponse = {
	WagerAmount?: number;
	TotalNetLoss?: number;
	ErrorDescription: string;
};

export type UserController_UpdateRealityCheckReminderRequest = {
	realityCheckIntervalMin: number;
};

export type UserController_GetSessionTimerResponse = {
	SessionTimer?: string;
};

export type UserController_ValidateGeoLocationRequest = {
	geoLocationEncryptedResponse: string;
	isPeriodicFlow: boolean;
	errorCode?: string;
	errorMsg?: string;
	failedLocationReason?: number;
};

export type UserController_ValidateGeoLocationResponse = {
	NextIntervalInSeconds?: number;
};

export type UserController_InitGeoRetryResponse = {
	GeoComplyLicense: string;
	GeoComplyWebLicense: string;
	LocationTransactionToken: string;
	ExtensionData: {
	};
	ErrorCode: number;
	ErrorDescription: string;
};

export type UserController_GetUserGameOrientationResponse = {
	groupId?: number;
	groupName: string;
};

export type UserController_SelfExclusionPanicRequest = {
	timezoneOffset: number;
	productPackage: number;
};

export type UserController_SelfExclusionPanicResponse = {
	errorID: number;
	errorDescription: string;
	hasErrors: boolean;
};

export type UserController_GetPlayerLimitsResponse = {
	displayableLimits: Array<{
		limitName: string;
		limitPeriods: Array<{
			value: number;
			typeId: number;
			unit: string;
			currency: string;
		}>;
	}>;
	ErrorCode: number;
	ErrorDescription: string;
};

export type UserController_GetPendingActionsRequest = {
	packageId?: number;
	eventTypeId?: number;
	playModeId?: number;
};

export type UserController_GetPendingActionsResponse = {
	PendingActions: Array<{
		Id: number;
		PlayModeId: number;
		Priority?: number;
		ReasonId: number;
		EventTypeId: number;
		EventTypeName: string;
	}>;
};

export type UserController_GetLastBetActivityRequest = {
	correlationId: string;
};

export type UserController_GetLastBetActivityResponse = {
	LastBetActivity?: number;
};

export class UserController extends ApiControllerBase {
	protected _getRoutePrefix() {
		return '/cgpapi/user/'
	}
	getToken(request: UserController_GetTokenRequest): Promise<UserController_GetTokenResponse> {
		return this._httpPost('gettoken', request);
	}

	getRealityCheckData(): Promise<UserController_GetRealityCheckDataResponse> {
		return this._httpPost('realityCheckData');
	}

	updateRealityCheckReminder(request: UserController_UpdateRealityCheckReminderRequest): Promise<any> {
		return this._httpPost('updateRealityCheckData', request);
	}

	getSessionTimer(): Promise<UserController_GetSessionTimerResponse> {
		return this._httpPost('getSessionTimer');
	}

	validateGeoLocation(request: UserController_ValidateGeoLocationRequest): Promise<UserController_ValidateGeoLocationResponse> {
		return this._httpPost('validateGeoLocation', request);
	}

	initGeoRetry(): Promise<UserController_InitGeoRetryResponse> {
		return this._httpPost('initGeoRetry');
	}

	getUserGameOrientation(): Promise<UserController_GetUserGameOrientationResponse> {
		return this._httpPost('getUserGameOrientation');
	}

	selfExclusionPanic(request: UserController_SelfExclusionPanicRequest): Promise<UserController_SelfExclusionPanicResponse> {
		return this._httpPost('selfExclusionPanic', request);
	}

	getPlayerLimits(): Promise<UserController_GetPlayerLimitsResponse> {
		return this._httpPost('getPlayerLimits');
	}

	getPendingActions(request: UserController_GetPendingActionsRequest): Promise<UserController_GetPendingActionsResponse> {
		return this._httpPost('getPendingActions', request);
	}

	getLastBetActivity(request: UserController_GetLastBetActivityRequest): Promise<UserController_GetLastBetActivityResponse> {
		return this._httpPost('getLastBetActivity', request);
	}

}

export class ApiService extends ServiceBase {
	constructor(services: IServiceFactoryExtended) {
		super(services);
		this.clockController = new ClockController(services);
		this.bonusManagerController = new BonusManagerController(services);
		this.featureToggleManagementController = new FeatureToggleManagementController(services);
		this.gamblingSessionController = new GamblingSessionController(services);
		this.gamesCorrelationController = new GamesCorrelationController(services);
		this.aBTestingController = new ABTestingController(services);
		this.insightController = new InsightController(services);
		this.jackpotBetsController = new JackpotBetsController(services);
		this.jackpotFeedsController = new JackpotFeedsController(services);
		this.locationController = new LocationController(services);
		this.netPositionController = new NetPositionController(services);
		this.oMGController = new OMGController(services);
		this.openSessionsController = new OpenSessionsController(services);
		this.restrictionRulerController = new RestrictionRulerController(services);
		this.restrictionsController = new RestrictionsController(services);
		this.thirdPartyFreePlayController = new ThirdPartyFreePlayController(services);
		this.userEligibilityController = new UserEligibilityController(services);
		this.gameController = new GameController(services);
		this.historyController = new HistoryController(services);
		this.userController = new UserController(services);
	}
	readonly clockController: ClockController;
	readonly bonusManagerController: BonusManagerController;
	readonly featureToggleManagementController: FeatureToggleManagementController;
	readonly gamblingSessionController: GamblingSessionController;
	readonly gamesCorrelationController: GamesCorrelationController;
	readonly aBTestingController: ABTestingController;
	readonly insightController: InsightController;
	readonly jackpotBetsController: JackpotBetsController;
	readonly jackpotFeedsController: JackpotFeedsController;
	readonly locationController: LocationController;
	readonly netPositionController: NetPositionController;
	readonly oMGController: OMGController;
	readonly openSessionsController: OpenSessionsController;
	readonly restrictionRulerController: RestrictionRulerController;
	readonly restrictionsController: RestrictionsController;
	readonly thirdPartyFreePlayController: ThirdPartyFreePlayController;
	readonly userEligibilityController: UserEligibilityController;
	readonly gameController: GameController;
	readonly historyController: HistoryController;
	readonly userController: UserController;
}
